<template>
  <v-app>
    <v-container class="grey lighten-5">
      <v-row
      class="mb-6 "
    >
      <v-col
          cols="4"
        
        >
          <v-card
          min-height='135'
            color="#006db3"
            dark
          >
           <div class="text-center" v-if='newUsers === null'>
            <v-progress-circular indeterminate class='mt-7' size="70"></v-progress-circular>
           </div>
            <div v-else class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title
                  class="headline"
                >New Users</v-card-title>
                <span class='ma-5 display-3'>{{newUsers}}</span>
              </div>

                <v-icon class='pr-5' size='100' dark>person</v-icon>
            </div>
          </v-card>
        </v-col>
        <v-col
          cols="4"
        >
          <v-card
          @click='changeRoute("myTask")'
          
          min-height='135'
            color="#039be5"
            dark
          >
            <div class="text-center">
           
           </div>
            <div class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title
                  class="headline"
                >Notifications</v-card-title>
                <span class='ma-5 display-3'>{{queueMessage.length}}</span>
              </div>

                <v-icon class='pr-5' size='100' dark>priority_high</v-icon>
            </div>
          </v-card>
        </v-col>
        <v-col
          cols="4"
         
        >
        
     <v-hover>
    <template v-slot:default="{ hover }">
          <v-card
          @click='changeRoute("myMessage")'
          min-height='135'
            color="#006db3"
            dark
          >
           <div class="text-center" v-if='!myMessage'>
            <v-progress-circular indeterminate class='mt-7' size="70"></v-progress-circular>
           </div>
            <div v-else class="d-flex flex-no-wrap justify-space-between">
              <div>
                <v-card-title
                  class="subtitle"
                >My Message </v-card-title>

                <span v-if='myMessage' class='ma-5 display-3'>{{ myMessage.message_to.length }} | {{ myMessage.message_from.length }}</span> 
              </div>

                <v-icon class='pr-5' size='100' dark>mail</v-icon>
            </div>
                 <v-fade-transition>
          <v-overlay
            v-if="hover"
            absolute
            color="black"
          >
             <span  class='ma-5 title'>Inbox | Sent Message</span> 
          </v-overlay>
        </v-fade-transition>
      </v-card>
      </template>
        </v-hover>
        </v-col>
       
          <v-col cols="6">
            <taskLists :taskList='taskList' @refreshmytask='getUserTasks'/>
          </v-col>
           <v-col cols="6">
            <v-card>
                <v-card-title>
      Notificatons
       <v-btn icon @click='getUserTasks()'>
        <v-icon title='refresh the list' >refresh</v-icon>
      </v-btn>

    </v-card-title>
      <TasksTable :headers='headers' :notificationLoading='notificationLoading' :queueMessage="queueMessage" @getUserTask='getUserTasks()' />
          </v-card>
          </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import TasksTable from "../components/myTasks/tasksTable"
import taskLists from '../components/TasksList'
import { postReq ,getnewUsers} from '../helper/firestore'
export default {
  data () {
    return {
      notificationLoading : true,
      queueMessage : [],
      taskList : null,
      newUsers : null,
       headers : [
         { text: 'User email', value: 'userEmail' },
         { text: 'Time', value: 'time' },
        { text: 'Notification Type', value: 'type' },
            { text: 'Description', value: 'content' },
            { text: 'Action',value: 'action'}
      ],
    }
  },
  mounted () {
    this.myMessage = null;
    this.newUsers = null;
    this.myTasksNum = null;
    this.getTasksList()

     postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/getalladmins', { idToken: this.user.idToken }, result => {
            if (result.status !== 200) { return }
            this.admins = result.data
        })
    postReq(process.env.VUE_APP_ROOT_API_URL + 'api/user/getUserData', { idToken: this.user.idToken }, result => {
      if (result.status !== 200) { return }
      else {
        this.user.email = result.data.info.email
        this.user.phone = result.data.info.phone
              if (result.data.name === undefined || result.data.name === null) { this.dialog = true }else{
                 this.user.name = result.data.info.name
              }
      }
    })
    this.getMessages()
    this.getUserTasks()
  },
  components: {
      taskLists,TasksTable
  },
  methods: {
      getMessages(){
        postReq(process.env.VUE_APP_ROOT_API_URL +'api/admin/messages/getmessages',{uid : this.user.uid},response =>{
      this.myMessage = response.data
      this.myMessageCount = this.myMessage.message_to.length + this.myMessage.message_from.length
        })
      },
        fullUpdate(){
          this.getUserTasks();
          this.getMessages();
        },
        getTasksList(){
         getnewUsers(this.user.idToken,result=>{
          this.taskList = result
          this.newUsers = result.length
    })
    },
    getUserTasks(){
        this.queueMessage = [];
          postReq(process.env.VUE_APP_ROOT_API_URL + 'api/admin/getmytasks', { gcid:this.user.uid,requestType:'open'}, result => { 
            if (result.status !== 200) { return }

            this.queueMessage = result.data
            this.notificationLoading = false;

    })
    },
    changeRoute(route){

      switch (route) {
        case "myTask" :
         this.$router.push('/tasks')
         break;
          case "myMessage" :
         this.$router.push('/admin/myMessage')
         break;
      }

    },
    autoLogout () {
      if (this.isAppIdle === true) {
        window.location.reload()
      }
    }
  },
  computed: {
    ...mapFields([
      'admins',
      'myTasks',
      'myMessage',
      'myMessageCount',
      'myHistory',
      'myTasksNum',
      'newTasks',
      'isAuthorized',
      'user',
      'snackBarshow',
      'snackBarType',
      'snackBarmessage',
    ]),
    messageStr () {
      if (this.isAppIdle === true) {
        alert("Session timeout...")
        this.autoLogout()
      }
      return this.isAppIdle
    }
  },
}
</script>
<style scoped>
.mainHov {
  transition: opacity 0.4s ease-in-out;
}

.mainHov:not(.on-hover) {
  opacity: 0.6;
}

.show-btns {
  color: rgba(255, 255, 255, 1) !important;
}
</style>